import { alias, createModelSchema } from "serializr";
import { SmartOfferBundle } from "../bundle-core/SmartOfferBundle";
import { SmartOfferBundleKind } from "../bundle-core/SmartOfferBundleKind";
import {Schema} from "@/common/Schema";

export class SmartOfferBundleTreasureTree extends SmartOfferBundle {

    constructor() {
        super(SmartOfferBundleKind.EXPEDITION_TREASURE_TREE);

        this._product = null;
    }

    get product() {
        return this._product;
    }

    set product(value) {
        this._product = value;
    }

    valid() {

        if (!this.product || this.product.length === 0) {
            return false;
        }

        return super.valid();
    }

    empty() {

        if (!this.product || this.product.length === 0) {
            return true;
        }

        return super.empty();
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new SmartOfferBundleTreasureTree());
        } else if (target instanceof SmartOfferBundleTreasureTree) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(SmartOfferBundleTreasureTree, {
    _product: alias("product", Schema.primitive())
});